import { FC } from "react";
import { BurnAssessment } from "./BurnAssessment";
import { SxProps, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { InfoPill } from "shared-ts-ui-info-pill";
import { SizeClass } from "shared-ts-ui-responsive";
import { Button_color } from "shared-ts-mui";
import { BurnAssessmentIcon } from "./BurnAssessmentIcon";

export interface BurnAssessmentInfoProps {
  value: BurnAssessment;
  color?: Button_color;
  variant?: "normal" | "outlined" | "filled";
  layout: SizeClass;
  sx?: SxProps;
}

export const BurnAssessmentInfo: FC<BurnAssessmentInfoProps> = (props) => {
  const { value, layout } = props;
  const { t } = useTranslation("firefly-shared-ts-domain");

  return (
    <InfoPill
      color={props.color}
      variant={props.variant}
      label={t("Ignition Quality")}
      layout={layout}
      info={
        <Tooltip title={t(`BurnAssessment.${value}`)}>
          <BurnAssessmentIcon value={value} />
        </Tooltip>
      }
    />
  );
};
